// import React from 'react';
// import ReactDOM from 'react-dom';

// ReactDOM.render(<div>working</div>, document.getElementById('root'));

import { createRoot } from 'react-dom/client';
import AppTemplate from './components/AppTemplate/AppTemplate.component';
const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(<AppTemplate />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
